export const KMeanEnum = {
  0: "Statie huishoudens",
  1: "Incidentele bezoekers",
  2: "Verhuizers en opruimers",
  3: "Afvalhelden",
  4: "Statie pro's",
};
